import { extractPdfTextBrowser as extractPdfText } from "@/services/pdf-extract";

/**
 * Extrai texto de um arquivo PDF no navegador usando PDF.js
 * @param file Arquivo PDF
 * @returns Texto extraído do PDF
 */
export async function extractPdfTextBrowser(file: File): Promise<string> {
  return extractPdfText(file);
}
